import api from './api'

/**
 * Serviço de Performance (Em desenvolvimento)
 */
export default {
  /**
   * Obter métricas de performance
   */
  getMetrics(params = {}) {
    return api.get('/api/performance', { params })
  },
}
